import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { DefaultValues } from "../../modules/calculation-defaults/lazy-pages";
import { CuratedCalculationFactors } from "../../modules/curated-calculation-factors/routes";
import { AdminRolesAuthorisationGuard } from "../../shared/auth/guards/admin-roles-authorisation.guard";
import { CFC_ROLE } from "../../shared/auth/guards/admin-roles-authorisation.guard.helpers";
import { ADMIN_ROUTE_SEGMENTS } from "../../shared/routing/paths/admin";

/**
 * The internal admin pages — not a module of its own, but the two modules that share one
 * role check:
 *
 *   curated-calculation-factors  /emission-factors/**  (module table: `modules/curated-calculation-factors/routes.tsx`)
 *   calculation-defaults        /default-values
 *
 * Pathless: the two URLs have no common prefix, only a common guard.
 */
export const AdminAreaRoutes = {
  element: (
    <AdminRolesAuthorisationGuard allowedRoles={[CFC_ROLE.ADMIN, CFC_ROLE.USER, CFC_ROLE.EMISSION_FACTOR_ADMIN]}>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </AdminRolesAuthorisationGuard>
  ),
  children: [
    { path: ADMIN_ROUTE_SEGMENTS.emissionFactors, children: CuratedCalculationFactors },
    { path: ADMIN_ROUTE_SEGMENTS.defaultValues, element: <DefaultValues /> },
  ],
};
